<!-- Main Container -->
<div #messageContainer class="message-container bg-white h-[calc(92vh-65px)] overflow-y-auto">

  <!-- Loading State -->
  <div *ngIf="loadingEmailData" class="h-full flex items-center justify-center">
    <div class="text-center">
      <div class="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
      <p class="text-gray-600 text-lg">Loading email content...</p>
    </div>
  </div>

  <!-- Compose/Reply/Forward Mode -->
  <div *ngIf="(isComposeOpen || isReply || isForward) && !loadingEmailData" class="h-full flex flex-col">

    <!-- Header -->
    <div
      class="flex items-center justify-between p-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
      <h2 class="text-xl font-semibold text-gray-800 flex items-center gap-2">
        <i class="pi pi-envelope text-blue-600"></i>
        <span *ngIf="!isReply && !isForward">Compose Mail</span>
        <span *ngIf="isReply">Reply</span>
        <span *ngIf="isForward">Forward</span>
      </h2>
      <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-text p-button-secondary"
        (onClick)="closeBottomSheet()" pTooltip="Close" tooltipPosition="left">
      </p-button>
    </div>

    <!-- Compose Form -->
    <div class="flex-1 overflow-auto p-6 space-y-4">

      <!-- To Field -->
      <div *ngIf="!isReply" class="space-y-3">
        <div class="flex items-center justify-between">
          <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
            <i class="pi pi-user text-gray-400"></i>
            To
          </label>
          <div class="flex gap-4 text-sm" *ngIf="!isForward">
            <span class="text-blue-600 cursor-pointer hover:text-blue-800 transition-colors" (click)="handleOpenCC()">
              + Cc
            </span>
          </div>
        </div>

        <!-- Email Input with Chips -->
        <div
          class="border border-gray-300 rounded-lg p-3 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 bg-white">
          <input id="to-email-input-unique-compose" name="toEmailInputCompose" type="text"
            class="w-full border-none outline-none bg-transparent" [(ngModel)]="emailInput" (keydown.enter)="addEmail()"
            placeholder="Enter email addresses..." autocomplete="new-password" autocapitalize="off" autocorrect="off"
            spellcheck="false" autofocus>

          <!-- Email Chips -->
          <div *ngIf="emails.length > 0" class="flex flex-wrap gap-2 mt-3">
            <p-chip *ngFor="let email of emails" [label]="email" [removable]="true" (onRemove)="removeEmail(email)"
              styleClass="bg-blue-100 text-blue-800 text-sm">
            </p-chip>
          </div>
        </div>
      </div>

      <!-- CC Field -->
      <div *ngIf="openCC && !isReply && !isForward" class="space-y-2">
        <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
          <i class="pi pi-users text-gray-400"></i>
          Cc
        </label>
        <div
          class="border border-gray-300 rounded-lg p-3 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 bg-white">
          <input id="cc-email-input-unique-compose" name="ccEmailInputCompose" type="text"
            class="w-full border-none outline-none bg-transparent" [(ngModel)]="ccInput" (keydown.enter)="addCc()"
            placeholder="Enter CC email addresses..." autocomplete="new-password" autocapitalize="off" autocorrect="off"
            spellcheck="false">

          <!-- CC Email Chips -->
          <div *ngIf="ccEmails.length > 0" class="flex flex-wrap gap-2 mt-3">
            <p-chip *ngFor="let ccEmail of ccEmails" [label]="ccEmail" [removable]="true" (onRemove)="removeCc(ccEmail)"
              styleClass="bg-green-100 text-green-800 text-sm">
            </p-chip>
          </div>
        </div>
      </div>

      <!-- Subject Field -->
      <div *ngIf="!isReply && !isForward" class="space-y-2">
        <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
          <i class="pi pi-tag text-gray-400"></i>
          Subject
        </label>
        <input pInputText class="w-full" [(ngModel)]="subject" placeholder="Enter subject...">
      </div>

      <!-- Rich Text Editor -->
      <div class="space-y-2">
        <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
          <i class="pi pi-file-edit text-gray-400"></i>
          Message
        </label>
        <div class="border border-gray-300 rounded-lg overflow-hidden"
        [style.height]="isReply || isForward ? '250px' : 'auto'"
        >
          <p-editor [(ngModel)]="editorData" [style]="{ height: '120px' }" placeholder="Type your message here...">
          </p-editor>
        </div>
      </div>

      <!-- File Attachments (New Uploads) -->
      <div #attachmentsSection *ngIf="files.length > 0" class="space-y-3 attachments-section">
        <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
          <i class="pi pi-paperclip text-gray-400"></i>
          New Attachments
        </label>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let file of files; let i = index"
            class="relative group bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow">

            <!-- File Preview -->
            <div class="aspect-square relative">
              <!-- Image -->
              <a *ngIf="isImage(file.file)" [href]="file.uploaded_url" target="_blank" class="block h-full">
                <img [src]="file.preview" class="w-full h-full object-cover">
              </a>

              <!-- Video -->
              <a *ngIf="isVideo(file.file)" [href]="file.uploaded_url" target="_blank" class="block h-full">
                <video [src]="file.preview" class="w-full h-full object-cover" muted></video>
              </a>

              <!-- PDF -->
              <a *ngIf="isPDF(file.file)" [href]="file.uploaded_url" target="_blank"
                class="flex items-center justify-center h-full bg-red-50">
                <i class="pi pi-file-pdf text-4xl text-red-500"></i>
              </a>

              <!-- Other Files -->
              <a *ngIf="!isImage(file.file) && !isVideo(file.file) && !isPDF(file.file)" [href]="file.uploaded_url"
                target="_blank" class="flex items-center justify-center h-full bg-gray-50">
                <i class="pi pi-file text-4xl text-gray-500"></i>
              </a>

              <!-- Remove Button - Enhanced with CSS class -->
              <button type="button" class="attachment-remove-btn" (click)="removeFile(i)" title="Remove attachment">
                <i class="pi pi-times"></i>
              </button>
            </div>

            <!-- File Info -->
            <div class="p-3">
              <p class="text-xs text-gray-600 truncate font-medium">{{ file.file?.name }}</p>
              <div class="flex items-center gap-2 mt-1">
                <span *ngIf="file.uploading" class="text-xs text-orange-600 flex items-center gap-1">
                  <i class="pi pi-spin pi-spinner"></i>
                  Uploading...
                </span>
                <span *ngIf="file.success" class="text-xs text-green-600 flex items-center gap-1">
                  <i class="pi pi-check-circle"></i>
                  Uploaded
                </span>
                <span *ngIf="file.error" class="text-xs text-red-600 flex items-center gap-1">
                  <i class="pi pi-exclamation-triangle"></i>
                  Failed
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Draft Attachments -->
      <div *ngIf="activeAction === 'drafts' && attachments.length > 0" class="space-y-3">
        <label class="text-sm font-medium text-gray-700 flex items-center gap-2">
          <i class="pi pi-paperclip text-gray-400"></i>
          Draft Attachments
        </label>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let attachment of attachments; let i = index"
            class="relative group bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow">

            <!-- File Preview -->
            <div class="aspect-square relative cursor-pointer" (click)="openAttachment(attachment)">
              <!-- Image -->
              <img *ngIf="attachment?.contentType?.startsWith('image/')"
                [src]="getImageUrl(attachment.contentType, attachment.contentBytes)" class="w-full h-full object-cover">

              <!-- Video -->
              <video *ngIf="attachment?.contentType?.startsWith('video/')"
                [src]="getImageUrl(attachment.contentType, attachment.contentBytes)" class="w-full h-full object-cover"
                muted></video>

              <!-- PDF -->
              <div *ngIf="attachment?.contentType === 'application/pdf'"
                class="flex items-center justify-center h-full bg-red-50">
                <i class="pi pi-file-pdf text-4xl text-red-500"></i>
              </div>

              <!-- Other Files -->
              <div *ngIf="!attachment?.contentType?.startsWith('image/') && 
                          !attachment?.contentType?.startsWith('video/') && 
                          attachment?.contentType !== 'application/pdf'"
                class="flex items-center justify-center h-full bg-gray-50">
                <i class="pi pi-file text-4xl text-gray-500"></i>
              </div>

              <!-- Remove Button - Enhanced with CSS class -->
              <button type="button" class="attachment-remove-btn" (click)="removeAttchment(i, attachment.id)"
                title="Remove attachment">
                <i class="pi pi-times"></i>
              </button>
            </div>

            <!-- File Info -->
            <div class="p-3">
              <p class="text-xs text-gray-600 truncate font-medium">{{ attachment?.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex items-center justify-between p-4 border-t border-gray-200 bg-gray-50">
      <div>
        <input type="file" (change)="onFileSelected($event)" multiple style="display: none;" #fileInput>
        <p-button label="Add Attachments" icon="pi pi-paperclip" styleClass="p-button-outlined p-button-secondary"
          (onClick)="fileInput.click()">
        </p-button>
      </div>

      <div class="flex gap-3">
        <!-- <p-button label="Save Draft" icon="pi pi-save" styleClass="p-button-outlined" *ngIf="!isReply && !isForward">
        </p-button> -->
        <p-button label="Send" icon="pi pi-send" styleClass="p-button-success" [loading]="btnLoading"
          (onClick)="sendMail()">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Reply/Forward Separator -->
  <p-divider *ngIf="isReply || isForward"></p-divider>

  <!-- Email View Mode -->
  <div
    *ngIf="(selectedRow?.sender?.emailAddress?.address || selectedRow?.receivedDateTime) && !isComposeOpen && !loadingEmailData"
    class="h-full flex flex-col">

    <!-- Email Header -->
    <div class="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-blue-50">
      <div class="space-y-4">
        <!-- Subject -->
        <h1 class="text-2xl font-bold text-gray-900">
          {{ selectedRow?.subject || 'No Subject' }}
        </h1>

        <!-- Date -->
        <div class="flex items-center gap-2 text-sm text-gray-600">
          <i class="pi pi-clock"></i>
          {{ selectedRow?.receivedDateTime | date: 'fullDate' }} at {{ selectedRow?.receivedDateTime | date: 'shortTime'
          }}
        </div>

        <!-- Sender Info -->
        <div class="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-200">
          <div
            class="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold">
            {{ getInitials(selectedRow?.sender?.emailAddress?.name) }}
          </div>
          <div class="flex-1">
            <div class="font-semibold text-gray-900">
              {{ selectedRow?.sender?.emailAddress?.name }}
            </div>
            <div class="text-sm text-gray-600" *ngIf="selectedRow?.sender?.emailAddress?.address">
              {{ selectedRow?.sender?.emailAddress?.address }}
            </div>
          </div>
        </div>

        <!-- Recipients -->
        <div class="space-y-3">
          <!-- To Recipients -->
          <div *ngIf="selectedRow?.toRecipients?.length > 0" class="flex items-start gap-3">
            <span class="text-sm font-medium text-gray-700 min-w-0">To:</span>
            <div class="flex flex-wrap gap-2 flex-1">
              <p-chip *ngFor="let recipient of selectedRow?.toRecipients" [label]="recipient?.emailAddress?.name"
                styleClass="bg-blue-100 text-blue-800 text-sm">
              </p-chip>
            </div>
          </div>

          <!-- CC Recipients -->
          <div *ngIf="selectedRow?.ccRecipients?.length > 0" class="flex items-start gap-3">
            <span class="text-sm font-medium text-gray-700 min-w-0">CC:</span>
            <div class="flex flex-wrap gap-2 flex-1">
              <p-chip *ngFor="let recipient of selectedRow?.ccRecipients" [label]="recipient?.emailAddress?.name"
                styleClass="bg-green-100 text-green-800 text-sm">
              </p-chip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email Content -->
    <div class="flex-1 p-6">
      <!-- HTML Content -->
      <div *ngIf="selectedRow?.body?.contentType === 'html'" class="prose max-w-none" [innerHTML]="sanitizedContent">
      </div>

      <!-- Text Content -->
      <div *ngIf="selectedRow?.body?.contentType === 'text'" class="whitespace-pre-wrap text-gray-800 leading-relaxed">
        {{ selectedRow?.body?.content }}
      </div>

      <!-- Attachments -->
      <div *ngIf="attachments.length > 0" class="mt-8 space-y-4">
        <h3 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <i class="pi pi-paperclip"></i>
          Attachments ({{ attachments.length }})
        </h3>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let attachment of attachments"
            class="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer group"
            (click)="openAttachment(attachment)">

            <!-- File Preview -->
            <div class="aspect-square relative">
              <!-- Image -->
              <img *ngIf="attachment?.contentType?.startsWith('image/')"
                [src]="getImageUrl(attachment.contentType, attachment.contentBytes)" class="w-full h-full object-cover">

              <!-- Video -->
              <video *ngIf="attachment?.contentType?.startsWith('video/')"
                [src]="getImageUrl(attachment.contentType, attachment.contentBytes)" class="w-full h-full object-cover"
                muted></video>

              <!-- PDF -->
              <div *ngIf="attachment?.contentType === 'application/pdf'"
                class="flex flex-col items-center justify-center h-full bg-red-50 text-red-600">
                <i class="pi pi-file-pdf text-4xl mb-2"></i>
                <span class="text-xs font-medium">PDF</span>
              </div>

              <!-- Other Files -->
              <div *ngIf="!attachment?.contentType?.startsWith('image/') && 
                          !attachment?.contentType?.startsWith('video/') && 
                          attachment?.contentType !== 'application/pdf'"
                class="flex flex-col items-center justify-center h-full bg-gray-50 text-gray-600">
                <i class="pi pi-file text-4xl mb-2"></i>
                <span class="text-xs font-medium">Download</span>
              </div>

              <!-- Hover Overlay -->
              <div
                class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i class="pi pi-eye text-white text-2xl"></i>
              </div>
            </div>

            <!-- File Info -->
            <div class="p-3 border-t border-gray-100">
              <p class="text-xs text-gray-600 truncate font-medium">{{ attachment?.name }}</p>
              <p class="text-xs text-gray-400 mt-1">{{ formatFileSize(attachment?.size) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reply Actions -->
    <div *ngIf="(activeAction === 'inbox' || activeAction === 'sent') && !isReply && !isForward && !isReplyAll"
      class="p-4 border-t border-gray-200 bg-gray-50">
      <div class="flex gap-3">
        <p-button label="Reply" icon="pi pi-reply" styleClass="p-button-outlined p-button-secondary"
          (onClick)="handleReply()">
        </p-button>
        <p-button label="Reply All" icon="pi pi-users" styleClass="p-button-outlined p-button-secondary"
          (onClick)="handleReplyAll()">
        </p-button>
        <p-button label="Forward" icon="pi pi-share-alt" styleClass="p-button-outlined p-button-secondary"
          (onClick)="handleForward()">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div
    *ngIf="selectedRow?.sender?.emailAddress?.address === null && selectedRow?.receivedDateTime === null && !isComposeOpen && !loadingEmailData"
    class="h-full flex flex-col items-center justify-center text-center">

    <div class="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
      <i class="pi pi-envelope text-4xl text-gray-400"></i>
    </div>

    <h2 class="text-2xl font-semibold text-gray-900 mb-3">
      Select an email to read
    </h2>

    <p class="text-gray-600 mb-6 max-w-sm">
      Choose an email from the list to view its content, reply, or take other actions.
    </p>

    <p-button label="Compose New Email" icon="pi pi-plus" styleClass="p-button-primary" (onClick)="openCompose()"
      *ngIf="!updateDraft">
    </p-button>
  </div>
</div>

<!-- Attachment Preview Dialog -->
<p-dialog header="Attachment Preview" [(visible)]="showAttachmentDialog" [modal]="true" [closable]="true"
  [maximizable]="true" [draggable]="false" [resizable]="true" styleClass="w-full max-w-4xl"
  [breakpoints]="{'960px': '75vw', '640px': '90vw'}">

  <!-- Dialog Content -->

  <div class="flex items-center justify-center dialog-header ">

    Attachment Preview

    <div class="absolute right-2">
      <button (click)="showAttachmentDialog = false" class="outline-none p-5">
        <i class="pi pi-times"></i>
      </button>
    </div>

  </div>

  <div class="flex flex-col items-center justify-center min-h-96 dialog-content" *ngIf="selectedAttachment">

    <!-- Image Viewer -->
    <img *ngIf="selectedAttachment?.contentType?.startsWith('image/')" [src]="selectedAttachment?.url"
      [alt]="selectedAttachment?.name" class="max-w-full max-h-96 rounded-lg shadow-lg object-contain">

    <!-- Video Viewer -->
    <video *ngIf="selectedAttachment?.contentType?.startsWith('video/')" [src]="selectedAttachment?.url" controls
      class="max-w-full max-h-96 rounded-lg shadow-lg">
    </video>

    <!-- PDF Viewer -->
    <iframe *ngIf="selectedAttachment?.contentType === 'application/pdf'" [src]="selectedAttachment?.url"
      class="w-full h-96 border-0 rounded-lg shadow-lg">
    </iframe>

    <!-- Default Viewer -->
    <div *ngIf="!selectedAttachment?.contentType?.startsWith('image/') && 
                !selectedAttachment?.contentType?.startsWith('video/') && 
                selectedAttachment?.contentType !== 'application/pdf'" class="text-center p-8">
      <i class="pi pi-file text-6xl text-gray-400 mb-4"></i>
      <p class="text-gray-600 mb-4">Cannot preview this file type.</p>
      <p-button label="Download File" icon="pi pi-download" styleClass="p-button-primary"
        (onClick)="downloadAttachment(selectedAttachment)">
      </p-button>
    </div>

    <!-- File Info -->
    <div class="mt-6 text-center">
      <h3 class="font-semibold text-lg text-gray-900 mb-2">{{ selectedAttachment?.name }}</h3>
      <p class="text-sm text-gray-600">{{ formatFileSize(selectedAttachment?.size) }}</p>
    </div>
  </div>
</p-dialog>

<!-- Toast for notifications -->
<p-toast position="top-right"></p-toast>